
import {defineComponent} from 'vue';
import {PropType} from "vue/dist/vue";
import {UIStateDto} from "@/dtos/UIStateDto";

export default defineComponent({
  name: "BaseDeleteButton",
  props: {
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    },
    deleteData: {
      type: Function,
      required: true
    },
    itemKey: {
      type: String,
      required: false
    },
    iconClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    isDeleting(): boolean {
      if (this.itemKey) {
        return this.pageUI.isItemDeleting(this.itemKey);
      }

      return this.pageUI.isDeleting();
    }
  }
});
